<div class="container">
  <div class="container__left">
    <div class="container__left__header">
      <p class="container__left__header__title">Disposition Groups</p>
      <div class="container__left__header__controls">
        <button
          mat-icon-button
          matTooltip="Add Disposition Group"
          (click)="openModal('AddDispositionGroup')"
          [appAuthorize]="NewPermission.DISPOSITIONS_CREATE"
          denyAction="disable"
        >
          <mat-icon svgIcon="add_circle_outline"></mat-icon>
        </button>
      </div>
    </div>
    <div class="container__left__nav">
      <ng-container *ngIf="dispositions$ | async as dispositions">
        <div
          *ngFor="let disposition of dispositions"
          class="container__left__nav__item"
          [class.selected]="selectedDispositionGroup?.id === disposition.id"
          (click)="select(disposition)"
        >
          <div class="container__left__nav__item__title">{{ disposition.name }}</div>
          <div class="container__left__nav__item__notes">
            <mat-icon svgIcon="description" matTooltip="Notes"></mat-icon>
            <p>{{ disposition.description }}</p>
          </div>
        </div>
        <div *ngIf="!dispositions?.length" class="container__left__nav__empty">No disposition groups found</div>
      </ng-container>
    </div>
  </div>
  <div class="container__right">
    <mat-progress-bar [class.visible]="ui.isLoading" mode="indeterminate"></mat-progress-bar>
    <div class="container__right__header">
      <p class="container__right__header__title">
        {{ selectedDispositionGroup?.name }}
        <button
          mat-icon-button
          (click)="openModal('EditDispositionGroup')"
          *ngIf="selectedDispositionGroup"
          [appAuthorize]="NewPermission.DISPOSITIONS_EDIT"
          denyAction="disable"
        >
          <mat-icon svgIcon="edit" class="icon-size-20"></mat-icon>
        </button>
      </p>
      <div class="container__right__header__controls">
        <button
          mat-flat-button
          color="primary"
          (click)="openModal('AddDisposition')"
          [disabled]="!selectedDispositionGroup"
          [appAuthorize]="NewPermission.DISPOSITIONS_CREATE"
          denyAction="disable"
        >
          <mat-icon svgIcon="add"></mat-icon>
          Add Offer
        </button>
        <button
          mat-icon-button
          [matMenuTriggerFor]="moreMenu"
          [disabled]="!selectedDispositionGroup"
          [appAuthorize]="NewPermission.DISPOSITIONS_DELETE"
        >
          <mat-icon svgIcon="more_vert"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item (click)="deleteGroup()">
            <mat-icon svgIcon="delete"></mat-icon>
            <span>Delete Disposition Group</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="container__right__content">
      <app-dispositions-table
        [dispositionGroup]="selectedDispositionGroup"
        [project]="project"
        [options]="options"
        [showActionsColumn]="true"
        (onOpenFilesAndCommentsDrawer)="onOpenFilesAndCommentsDrawer($event)"
        (onDispositionEditedUpdated)="onDispositionEditedUpdated($event)"
      ></app-dispositions-table>
    </div>
  </div>
</div>
